module.exports = __webpack_public_path__ + "img/thumbnail_Meerkat_f_normal.086f03f6.png";